import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface XPTickerProps {
    xp: number;
    show: boolean;
}

export default function XPTicker({ xp, show }: XPTickerProps) {
    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    key={xp + Date.now()}
                    initial={{ opacity: 1, y: 0, scale: 1 }}
                    animate={{ opacity: 0, y: -64, scale: 1.2 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.9, ease: 'easeOut' }}
                    className="absolute top-0 right-0 pointer-events-none z-50 font-heading font-black text-game-accent text-xl drop-shadow-[0_0_8px_rgba(16,185,129,0.8)]"
                >
                    +{xp} XP
                </motion.div>
            )}
        </AnimatePresence>
    );
}
